import React from "react";
import { Header, Segment, Table } from "semantic-ui-react";
import { SafeMoment } from "../../../../components/SafeMoment";
import CurrencyFormat from "react-currency-format";

interface PrintTransactions {
  transactions: any;
}

export const PrintTransactions = ({ transactions }: PrintTransactions) => {
  return (
    <Segment vertical className='printable-tables'>
      <Header content='Transaction Log' />
      <Table size='small' style={{ fontSize: 13 }}>
        <Table.Body>
          {transactions?.map((transaction: any, index: number) => {
            const {
              type,
              category,
              method,
              comment,
              main_amount,
              amount,
              confirmed_at,
              created_at,
              stripe_status,
              convenience_fee_in_cents,
              cash_register,
            } = transaction.attributes;

            return (
              <Table.Row key={index}>
                <Table.Cell className='transaction-cell'>
                  <div className='top-row'>
                    <SafeMoment style={{ fontWeight: "bold" }} format='L'>
                      {confirmed_at || created_at}
                    </SafeMoment>
                    <p className='table-over-text' style={{ marginLeft: 8, textTransform: "capitalize" }}>
                      {stripe_status == "warning_needs_response"
                        ? "Dispute - Warning"
                        : type == "chargeback"
                        ? "Dispute"
                        : type}
                    </p>
                    <p className='table-under-text' style={{ paddingLeft: 28 }}>
                      {type == "ChargeBack" ? category : method}
                    </p>
                  </div>
                  <div className='bottom-row'>
                    {cash_register?.name && <p>{`${cash_register?.name}`}</p>}
                    {comment && <p>{`${comment}`}</p>}
                    {convenience_fee_in_cents && (
                      <p>
                        Non-refundable convenience fee of{" "}
                        <CurrencyFormat
                          value={convenience_fee_in_cents / 100}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </p>
                    )}
                  </div>
                </Table.Cell>
                <Table.Cell collapsing style={{ fontWeight: "bold", textAlign: "right" }}>
                  <CurrencyFormat
                    value={(type == "Payment" ? main_amount : amount) / 100}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </Segment>
  );
};

export default PrintTransactions;
